import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';

class LangSelector extends Component {
  render() {
    return (
      <div className="up12 margin">

          <div className="cell s-6 tar">
            <span className={` ttu ${this.props.translateStore.t.locale == "en"?"clear b1 tdni bold ":"pointer"}`} onClick={(e)=>{ e.preventDefault(); this.props.translateStore.lang="en"; }}>en</span>
          </div>
          <div className="cell s-6 tal">
            <span className={` ttu ${this.props.translateStore.t.locale == "ru"?"clear b1 tdni bold":"pointer"}`} onClick={(e)=>{ e.preventDefault(); this.props.translateStore.lang="ru"; }}>ru</span>
          </div>

        </div>
    )
  }
}


// export default connect(mapStateToProps,{ fetchTranslate })(LangSelector);
export default inject("translateStore")(observer(LangSelector));